import React, { SetStateAction, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, Snackbar, TableFooter, TablePagination } from "@mui/material";
import { Stack } from "@mui/material";
import { Paper } from "@mui/material";
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { TableContainer } from "@mui/material";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableHead, StyledTableCell, } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import BasicPopover from "../../../Components/Popover";
import { IQuantidadeEP } from "../../../Interfaces/cadernos/caderno11";
import { Alert } from "../../../Components/Alert/Alert";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { format_strings_to_numbers, somaTotal } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";

interface IQuantidadeEPProps {
  obj_quantidade_EP: IQuantidadeEP | undefined;
  rows: IQuantidadeEP[];
  set_obj_quantidade_EP: React.Dispatch<SetStateAction<IQuantidadeEP | undefined>>;
  setRows: React.Dispatch<SetStateAction<IQuantidadeEP[]>>;
}

export const QuantidadeEPForm: React.FC<IQuantidadeEPProps> = ({
  obj_quantidade_EP,
  rows,
  setRows,
  set_obj_quantidade_EP
}) => {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [isLoading, setIsLoading] = useState(false);

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [error_n_animais, set_error_n_animais] = useState<boolean>(false);
  const [error_ex_chorume, set_error_ex_chorume] = useState<boolean>(false);
  const [error_ex_estrume, set_error_ex_estrume] = useState<boolean>(false);
  const [error_exter_chorume, set_error_exter_chorume] = useState<boolean>(false);
  const [error_exter_estrume, set_error_exter_estrume] = useState<boolean>(false);
  const [error_vendido_chorume, set_error_vendido_chorume] = useState<boolean>(false);
  const [error_vendido_estrume, set_error_vendido_estrume] = useState<boolean>(false);
  const [error_quant_chorume, set_error_quant_chorume] = useState<boolean>(false);
  const [error_quant_estrume, set_error_quant_estrume] = useState<boolean>(false);
  const message_apenas_numero = ("Apenas números são aceites");

  const [total_ex_chorume, set_total_ex_chorume] = useState<number>(0);
  const [total_ex_estrume, set_total_ex_estrume] = useState<number>(0);
  const [total_exter_chorume, set_total_exter_chorume] = useState<number>(0);
  const [total_exter_estrume, set_total_exter_estrume] = useState<number>(0);
  const [total_vendido_chorume, set_total_vendido_chorume] = useState<number>(0);
  const [total_vendido_estrume, set_total_vendido_estrume] = useState<number>(0);
  const [total_quant_chorume, set_total_quant_chorume] = useState<number>(0);
  const [total_quant_estrume, set_total_quant_estrume] = useState<number>(0);

  const [openDelete, setOpenDelete] = React.useState(false);
  const [createTable, setCreateTable] = useState(false);

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handleCancel()


    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  const sumatorio_das_quantidades = (lista: IQuantidadeEP[]) => {

    let total_ex_chorume_final = 0
    let total_ex_estrume_final = 0
    let total_exter_chorume_final = 0
    let total_exter_estrume_final = 0
    let total_vendido_chorume_final = 0
    let total_vendido_estrume_final = 0
    let total_quant_chorume_final = 0
    let total_quant_estrume_final = 0

    lista.forEach((el) => {
      total_ex_chorume_final += el.ex_chorume
      total_ex_estrume_final += el.ex_estrume
      total_exter_chorume_final += el.exter_chorume
      total_exter_estrume_final += el.exter_estrume
      total_vendido_chorume_final += el.vendido_chorume
      total_vendido_estrume_final += el.vendido_estrume
      total_quant_chorume_final += el.quant_chorume
      total_quant_estrume_final += el.quant_estrume
    })

    set_total_ex_chorume(total_ex_chorume_final)
    set_total_ex_estrume(total_ex_estrume_final)
    set_total_exter_chorume(total_exter_chorume_final)
    set_total_exter_estrume(total_exter_estrume_final)
    set_total_vendido_chorume(total_vendido_chorume_final)
    set_total_vendido_estrume(total_vendido_estrume_final)
    set_total_quant_chorume(total_quant_chorume_final)
    set_total_quant_estrume(total_quant_estrume_final)
  }


  async function getTabela() {
    setIsLoading(true);
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_gest_fluentes_onze_dois_rosto/${location.state.id_rosto}`);

      if (res.status === 200) {
        setRows(res.data.result);
        sumatorio_das_quantidades(res.data.result)

      }
      setIsLoading(false);
    } catch (error) {
      func_print("getAgua", error, true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getTabela();
    })();
  }, []);

  //Criar
  const handleCancel = () => {
    setCreateTable(false);
    set_obj_quantidade_EP(undefined);
    set_error_ex_chorume(false);
    set_error_ex_estrume(false);
    set_error_exter_chorume(false);
    set_error_exter_estrume(false);
    set_error_n_animais(false);
    set_error_quant_chorume(false);
    set_error_quant_estrume(false);
    set_error_vendido_chorume(false);
    set_error_vendido_estrume(false);
  }

  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)


    if (name === "n_animais") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_n_animais(true);

      } else {
        set_error_n_animais(false);

        set_obj_quantidade_EP((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ex_chorume") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ex_chorume(true);
      } else {
        set_error_ex_chorume(false);
        set_obj_quantidade_EP((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ex_estrume") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ex_estrume(true);
      } else {
        set_error_ex_estrume(false);
        set_obj_quantidade_EP((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "exter_chorume") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_exter_chorume(true);
      } else {
        set_error_exter_chorume(false);
        set_obj_quantidade_EP((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "exter_estrume") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_exter_estrume(true);
      } else {
        set_error_exter_estrume(false);
        set_obj_quantidade_EP((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "vendido_chorume") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_vendido_chorume(true);
      } else {
        set_error_vendido_chorume(false);
        set_obj_quantidade_EP((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "vendido_estrume") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_vendido_estrume(true);
      } else {
        set_error_vendido_estrume(false);
        set_obj_quantidade_EP((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "quant_chorume") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_quant_chorume(true);
      } else {
        set_error_quant_chorume(false);
        set_obj_quantidade_EP((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "quant_estrume") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_quant_estrume(true);
      } else {
        set_error_quant_estrume(false);
        set_obj_quantidade_EP((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else {
      set_obj_quantidade_EP((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: value,
      }));
    }

  };

  const handleSave = async () => {


    try {
      setIsLoading(true);
      let res = await post(auth.token.cookie_token, "new_reg_gest_fluentes_onze_dois", {
        payload: {
          id_fluentes_dois: 0,
          categoria_animal: obj_quantidade_EP?.categoria_animal === undefined ? "" : obj_quantidade_EP.categoria_animal,
          especie_animal: obj_quantidade_EP?.especie_animal === undefined ? "" : obj_quantidade_EP.especie_animal,
          n_animais: obj_quantidade_EP?.n_animais === undefined ? null : Math.trunc(Number(obj_quantidade_EP.n_animais)),
          ex_chorume: obj_quantidade_EP?.ex_chorume === undefined ? null : obj_quantidade_EP.ex_chorume,
          ex_estrume: obj_quantidade_EP?.ex_estrume === undefined ? null : obj_quantidade_EP.ex_estrume,
          exter_chorume: obj_quantidade_EP?.exter_chorume === undefined ? null : obj_quantidade_EP.exter_chorume,
          exter_estrume: obj_quantidade_EP?.exter_estrume === undefined ? null : obj_quantidade_EP.exter_estrume,
          vendido_chorume: obj_quantidade_EP?.vendido_chorume === undefined ? null : obj_quantidade_EP.vendido_chorume,
          vendido_estrume: obj_quantidade_EP?.vendido_estrume === undefined ? null : obj_quantidade_EP.vendido_estrume,
          quant_chorume: obj_quantidade_EP?.quant_chorume === undefined ? null : obj_quantidade_EP.quant_chorume,
          quant_estrume: obj_quantidade_EP?.quant_estrume === undefined ? null : obj_quantidade_EP.quant_estrume,
          id_rosto: location.state.id_rosto,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      });

      if (res.status === 200) {
        setMessage("Gravado com sucesso!");
        const resultArray = rows
        resultArray.push(res.data.result)
        setRows(resultArray);
        sumatorio_das_quantidades(resultArray)
        set_flag_editado(false)

        set_obj_quantidade_EP(undefined);

        setOpenSnackSuccess(true);
        setCreateTable(false);
        set_error_ex_chorume(false);
        set_error_ex_estrume(false);
        set_error_exter_chorume(false);
        set_error_exter_estrume(false);
        set_error_n_animais(false);
        set_error_quant_chorume(false);
        set_error_quant_estrume(false);
        set_error_vendido_chorume(false);
        set_error_vendido_estrume(false);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);

    } catch (error) {
      func_print("handleSave", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }

  };

  /********** EDITAR LINHA *************/
  const handleEdit = (obj: IQuantidadeEP) => {
    set_obj_quantidade_EP(obj)
    setCreateTable(false);

    let total_ex_chorume_final = 0
    let total_ex_estrume_final = 0
    let total_exter_chorume_final = 0
    let total_exter_estrume_final = 0
    let total_vendido_chorume_final = 0
    let total_vendido_estrume_final = 0
    let total_quant_chorume_final = 0
    let total_quant_estrume_final = 0


    total_ex_chorume_final = total_ex_chorume - obj.ex_chorume
    total_ex_estrume_final = total_ex_estrume - obj.ex_estrume
    total_exter_chorume_final = total_exter_chorume - obj.exter_chorume
    total_exter_estrume_final = total_exter_estrume - obj.exter_estrume
    total_vendido_chorume_final = total_vendido_chorume - obj.vendido_chorume
    total_vendido_estrume_final = total_vendido_estrume - obj.vendido_estrume
    total_quant_chorume_final = total_quant_chorume - obj.quant_chorume
    total_quant_estrume_final = total_quant_estrume - obj.quant_estrume

    set_total_ex_chorume(total_ex_chorume_final)
    set_total_ex_estrume(total_ex_estrume_final)
    set_total_exter_chorume(total_exter_chorume_final)
    set_total_exter_estrume(total_exter_estrume_final)
    set_total_vendido_chorume(total_vendido_chorume_final)
    set_total_vendido_estrume(total_vendido_estrume_final)
    set_total_quant_chorume(total_quant_chorume_final)
    set_total_quant_estrume(total_quant_estrume_final)
  };



  const handleUpdate = async () => {

    try {
      let res = await post(auth.token.cookie_token, "update_reg_gest_fluentes_onze_dois", {
        payload: {
          id_fluentes_dois: obj_quantidade_EP?.id_fluentes_dois,
          categoria_animal: obj_quantidade_EP?.categoria_animal === undefined ? "" : obj_quantidade_EP?.categoria_animal,
          especie_animal: obj_quantidade_EP?.especie_animal === undefined ? "" : obj_quantidade_EP?.especie_animal,
          n_animais: obj_quantidade_EP?.n_animais === undefined ? null : Math.trunc(Number(obj_quantidade_EP?.n_animais)),
          ex_chorume: obj_quantidade_EP?.ex_chorume === undefined ? null : obj_quantidade_EP?.ex_chorume,
          ex_estrume: obj_quantidade_EP?.ex_estrume === undefined ? null : obj_quantidade_EP?.ex_estrume,
          exter_chorume: obj_quantidade_EP?.exter_chorume === undefined ? null : obj_quantidade_EP?.exter_chorume,
          exter_estrume: obj_quantidade_EP?.exter_estrume === undefined ? null : obj_quantidade_EP?.exter_estrume,
          vendido_chorume: obj_quantidade_EP?.vendido_chorume === undefined ? null : obj_quantidade_EP?.vendido_chorume,
          vendido_estrume: obj_quantidade_EP?.vendido_estrume === undefined ? null : obj_quantidade_EP?.vendido_estrume,
          quant_chorume: obj_quantidade_EP?.quant_chorume === undefined ? null : obj_quantidade_EP?.quant_chorume,
          quant_estrume: obj_quantidade_EP?.quant_estrume === undefined ? null : obj_quantidade_EP?.quant_estrume,
          id_rosto: obj_quantidade_EP?.id_rosto,
          last_update: obj_quantidade_EP?.last_update,
          create_date: obj_quantidade_EP?.create_date,
          uuid: obj_quantidade_EP?.uuid,
        }
      });

      if (res.status === 200) {
        setMessage("Registado com sucesso!");

        const updatedRows = rows.map((row) => {
          if (row.id_fluentes_dois === obj_quantidade_EP?.id_fluentes_dois) {
            return res.data.result
          } else {
            return row;
          }
        });
        setRows(updatedRows !== undefined ? updatedRows : []);
        sumatorio_das_quantidades(updatedRows)
        set_obj_quantidade_EP(undefined);
        setOpenSnackSuccess(true);
        set_error_ex_chorume(false);
        set_error_ex_estrume(false);
        set_error_exter_chorume(false);
        set_error_exter_estrume(false);
        set_error_n_animais(false);
        set_error_quant_chorume(false);
        set_error_quant_estrume(false);
        set_error_vendido_chorume(false);
        set_error_vendido_estrume(false);
        set_flag_editado(false)

      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleUpdate", error, true);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);
      setIsLoading(false);
    }


  };

  // DELETE
  const handleClickOpenDelete = (obj: IQuantidadeEP) => {
    set_obj_quantidade_EP(obj);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete_gest_fluentes_onze_dois/${obj_quantidade_EP?.id_fluentes_dois}`);

      if (res.status === 200) {
        setMessage("Eliminado com sucesso!");
        let aux_array = rows.filter((oldRow) => oldRow.id_fluentes_dois !== obj_quantidade_EP?.id_fluentes_dois)

        setRows(aux_array);
        sumatorio_das_quantidades(aux_array)

        set_obj_quantidade_EP(undefined)
        setOpenDelete(false);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  /*****************  PAGINAÇÃO ********************** */
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <CustomThemeProvider>
      {isLoading ?
        <LoadingVulpes /> :
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <table style={{ width: "100%" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={9}
                  sx={{
                    fontWeight: 600,
                    textAlign: "left",
                    fontFamily: "candara",
                    fontSize: 16,
                  }}
                >
                  2 - Quantidade de efluentes pecuários produzidos na exploração
                  agrícola, adquiridos externamente e vendidos/cedidos a
                  terceiros.
                </TableCell>
                <TableCell colSpan={3}>
                  <Box sx={{ display: "flex", justifyContent: "end" }}>
                    {is_historico === true ? <></> :

                      <BarraDeFerramentas
                        mostrarBotaoNovo
                        textoBotaoNovo="Novo Registo"
                        aoClicarNovo={() => {
                          set_obj_quantidade_EP(undefined)
                          setCreateTable(true)
                        }}
                      />}
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead rowSpan={3}>Categoria animal</StyledTableHead>
                <StyledTableHead rowSpan={3}>Espécie animal </StyledTableHead>
                <StyledTableHead rowSpan={3}>N.º de animais</StyledTableHead>
                <StyledTableHead colSpan={6}>
                  Quantidade de efluentes pecuários
                </StyledTableHead>
                <StyledTableHead rowSpan={2} colSpan={2}>
                  Quantidade de N
                </StyledTableHead>
                <StyledTableHead rowSpan={3}>Ações</StyledTableHead>
              </TableRow>
              <TableRow>
                <StyledTableHead colSpan={2}>Exploração</StyledTableHead>
                <StyledTableHead colSpan={2}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Externa
                    <BasicPopover text={"Na gestão de efluentes pecuários, devem ser registadas na origem as informações e os documentos relativos à venda/cedência\n a terceiros e relativos a efluentes adquiridos externamente à exploração agrícola, de onde conste:\ni) A dat em que os efluentes pecuários foram retirados da instalação de origem ou recebidos na instalação de destino;\nii) A composição do produto, a sua caracterização físico-química e a identificação da espécie animal que o produziu;\niii) A quantidade das matérias transportadas (em peso ou volume);\niv) A identificação e o endereço do transportador, bem como a identificação do veículo de transporte;\nv) A identificação e o endereço do destino ou da origem, bem como o respetivo número de registo da exploração.\nOs registos referidos nas sub-alíneas i) a v) do presente anexo devem ser conservados por um período mínimo de cinco anos\n para apresentação às autoridades competentes, quando solicitados."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead colSpan={2}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Vendido/cedido a terceiros
                    <BasicPopover text={"Na gestão de efluentes pecuários, devem ser registadas na origem as informações e os documentos relativos à venda/cedência\n a terceiros e relativos a efluentes adquiridos externamente à exploração agrícola, de onde conste:\ni) A dat em que os efluentes pecuários foram retirados da instalação de origem ou recebidos na instalação de destino;\nii) A composição do produto, a sua caracterização físico-química e a identificação da espécie animal que o produziu;\niii) A quantidade das matérias transportadas (em peso ou volume);\niv) A identificação e o endereço do transportador, bem como a identificação do veículo de transporte;\nv) A identificação e o endereço do destino ou da origem, bem como o respetivo número de registo da exploração.\nOs registos referidos nas sub-alíneas i) a v) do presente anexo devem ser conservados por um período mínimo de cinco anos\n para apresentação às autoridades competentes, quando solicitados."} />
                  </Stack>
                </StyledTableHead>
              </TableRow>
              <TableRow>
                <StyledTableHead>Chorume (m3/ano)</StyledTableHead>
                <StyledTableHead>Estrume (t/ano)</StyledTableHead>
                <StyledTableHead>Chorume (m3/ano)</StyledTableHead>
                <StyledTableHead>Estrume (t/ano)</StyledTableHead>
                <StyledTableHead>Chorume (m3/ano)</StyledTableHead>
                <StyledTableHead>Estrume (t/ano)</StyledTableHead>
                <StyledTableHead>Chorume (m3/ano)</StyledTableHead>
                <StyledTableHead>Estrume (t/ano)</StyledTableHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {createTable && (
                <>
                  <StyledTableCell>
                    <CustomTextField
                      name="categoria_animal"
                      value={obj_quantidade_EP?.categoria_animal}
                      onChange={onInputChange}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="especie_animal"
                      value={obj_quantidade_EP?.especie_animal === undefined ? "" : obj_quantidade_EP.especie_animal}
                      onChange={onInputChange}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="n_animais"
                      value={obj_quantidade_EP?.n_animais === undefined ? "" : obj_quantidade_EP.n_animais}
                      onChange={onInputChange}
                      error={error_n_animais}
                      helperText={error_n_animais ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="ex_chorume"
                      value={obj_quantidade_EP?.ex_chorume === undefined ? "" : obj_quantidade_EP.ex_chorume}
                      onChange={onInputChange}
                      error={error_ex_chorume}
                      helperText={error_ex_chorume ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="ex_estrume"
                      value={obj_quantidade_EP?.ex_estrume === undefined ? "" : obj_quantidade_EP.ex_estrume}
                      onChange={onInputChange}
                      error={error_ex_estrume}
                      helperText={error_ex_estrume ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="exter_chorume"
                      value={obj_quantidade_EP?.exter_chorume === undefined ? "" : obj_quantidade_EP.exter_chorume}
                      onChange={onInputChange}
                      error={error_exter_chorume}
                      helperText={error_exter_chorume ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="exter_estrume"
                      value={obj_quantidade_EP?.exter_estrume === undefined ? "" : obj_quantidade_EP.exter_estrume}
                      onChange={onInputChange}
                      error={error_exter_estrume}
                      helperText={error_exter_estrume ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="vendido_chorume"
                      value={obj_quantidade_EP?.vendido_chorume === undefined ? "" : obj_quantidade_EP.vendido_chorume}
                      onChange={onInputChange}
                      error={error_vendido_chorume}
                      helperText={error_vendido_chorume ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="vendido_estrume"
                      value={obj_quantidade_EP?.vendido_estrume === undefined ? "" : obj_quantidade_EP.vendido_estrume}
                      onChange={onInputChange}
                      error={error_vendido_estrume}
                      helperText={error_vendido_estrume ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="quant_chorume"
                      value={obj_quantidade_EP?.quant_chorume === undefined ? "" : obj_quantidade_EP.quant_chorume}
                      onChange={onInputChange}
                      error={error_quant_chorume}
                      helperText={error_quant_chorume ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="quant_estrume"
                      value={obj_quantidade_EP?.quant_estrume === undefined ? "" : obj_quantidade_EP.quant_estrume}
                      onChange={onInputChange}
                      error={error_quant_estrume}
                      helperText={error_quant_estrume ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" justifyContent="center">
                      <ButtonCadernos
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            handleCancel()
                          }
                        }}
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleSave()}
                      />
                    </Stack>
                  </StyledTableCell>
                </>
              )}

              {(rowsPerPage > 0
                ? rows.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
                : rows
              ).map((row, key) => (
                <TableRow key={key}>
                  {obj_quantidade_EP?.id_fluentes_dois === row.id_fluentes_dois ? (
                    <>
                      <StyledTableCell>
                        <CustomTextField
                          name="categoria_animal"
                          value={obj_quantidade_EP?.categoria_animal}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="especie_animal"
                          value={obj_quantidade_EP?.especie_animal}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="n_animais"
                          value={obj_quantidade_EP?.n_animais}
                          onChange={onInputChange}
                          error={error_n_animais}
                          helperText={error_n_animais ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="ex_chorume"
                          value={obj_quantidade_EP?.ex_chorume === undefined || obj_quantidade_EP?.ex_chorume === null ? "" : obj_quantidade_EP.ex_chorume.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_ex_chorume}
                          helperText={error_ex_chorume ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="ex_estrume"
                          value={obj_quantidade_EP?.ex_estrume === undefined || obj_quantidade_EP?.ex_estrume === null ? "" : obj_quantidade_EP.ex_estrume.toString().replace('.', ',')}

                          onChange={onInputChange}
                          error={error_ex_estrume}
                          helperText={error_ex_estrume ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="exter_chorume"
                          value={obj_quantidade_EP?.exter_chorume === undefined || obj_quantidade_EP?.exter_chorume === null ? "" : obj_quantidade_EP.exter_chorume.toString().replace('.', ',')}

                          onChange={onInputChange}
                          error={error_exter_chorume}
                          helperText={error_exter_chorume ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="exter_estrume"
                          value={obj_quantidade_EP?.exter_estrume === undefined || obj_quantidade_EP?.exter_estrume === null ? "" : obj_quantidade_EP.exter_estrume.toString().replace('.', ',')}

                          onChange={onInputChange}
                          error={error_exter_estrume}
                          helperText={error_exter_estrume ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="vendido_chorume"
                          value={obj_quantidade_EP?.vendido_chorume === undefined || obj_quantidade_EP?.vendido_chorume === null ? "" : obj_quantidade_EP.vendido_chorume.toString().replace('.', ',')}

                          onChange={onInputChange}
                          error={error_vendido_chorume}
                          helperText={error_vendido_chorume ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="vendido_estrume"
                          value={obj_quantidade_EP?.vendido_estrume === undefined || obj_quantidade_EP?.vendido_estrume === null ? "" : obj_quantidade_EP.vendido_estrume.toString().replace('.', ',')}

                          onChange={onInputChange}
                          error={error_vendido_estrume}
                          helperText={error_vendido_estrume ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="quant_chorume"
                          value={obj_quantidade_EP?.quant_chorume === undefined || obj_quantidade_EP?.quant_chorume === null ? "" : obj_quantidade_EP.quant_chorume.toString().replace('.', ',')}

                          onChange={onInputChange}
                          error={error_quant_chorume}
                          helperText={error_quant_chorume ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="quant_estrume"
                          value={obj_quantidade_EP?.quant_estrume === undefined || obj_quantidade_EP?.quant_estrume === null ? "" : obj_quantidade_EP.quant_estrume.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_quant_estrume}
                          helperText={error_quant_estrume ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                    </>
                  ) : (
                    <>
                      <StyledTableCell>{row.categoria_animal} </StyledTableCell>
                      <StyledTableCell>{row.especie_animal} </StyledTableCell>
                      <StyledTableCell>{row.n_animais}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.ex_chorume)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.ex_estrume)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.exter_chorume)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.exter_estrume)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.vendido_chorume)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.vendido_estrume)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.quant_chorume)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.quant_estrume)}</StyledTableCell>
                    </>
                  )}
                  {obj_quantidade_EP?.id_fluentes_dois === row.id_fluentes_dois ? (
                    <StyledTableCell>
                      <ButtonCadernos
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleUpdate()}
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            handleCancel()
                          }
                        }}
                      />
                    </StyledTableCell>
                  ) : (
                    <StyledTableCell>
                      {is_historico === true ? <></> :

                        <ButtonCadernos
                          mostrarBotaoEditar
                          aoClicarEditar={() => handleEdit(row)}
                          mostrarBotaoApagar
                          aoClicarApagar={() => handleClickOpenDelete(row)}
                        />}
                    </StyledTableCell>
                  )}
                </TableRow>
              ))}
              <TableRow>
                <StyledTableCell colSpan={3} sx={{ textAlign: "right" }}>
                  {"Totais:"}
                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_quantidade_EP?.ex_chorume !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_ex_chorume) + Number(obj_quantidade_EP?.ex_chorume)) :
                      formatarNumero_recebido_com_casa_decimais(total_ex_chorume)
                  }
                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_quantidade_EP?.ex_estrume !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_ex_estrume) + Number(obj_quantidade_EP?.ex_estrume)) :
                      formatarNumero_recebido_com_casa_decimais(total_ex_estrume)
                  }
                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_quantidade_EP?.exter_chorume !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_exter_chorume) + Number(obj_quantidade_EP?.exter_chorume)) :
                      formatarNumero_recebido_com_casa_decimais(total_exter_chorume)
                  }
                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_quantidade_EP?.exter_estrume !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_exter_estrume) + Number(obj_quantidade_EP?.exter_estrume)) :
                      formatarNumero_recebido_com_casa_decimais(total_exter_estrume)
                  }
                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_quantidade_EP?.vendido_chorume !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_vendido_chorume) + Number(obj_quantidade_EP?.vendido_chorume)) :
                      formatarNumero_recebido_com_casa_decimais(total_vendido_chorume)
                  }
                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_quantidade_EP?.vendido_estrume !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_vendido_estrume) + Number(obj_quantidade_EP?.vendido_estrume)) :
                      formatarNumero_recebido_com_casa_decimais(total_vendido_estrume)
                  }
                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_quantidade_EP?.quant_chorume !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_quant_chorume) + Number(obj_quantidade_EP?.quant_chorume)) :
                      formatarNumero_recebido_com_casa_decimais(total_quant_chorume)
                  }
                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_quantidade_EP?.quant_estrume !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_quant_estrume) + Number(obj_quantidade_EP?.quant_estrume)) :
                      formatarNumero_recebido_com_casa_decimais(total_quant_estrume)
                  }
                </StyledTableCell>
              </TableRow>
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={12} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow sx={{ width: "100%" }}>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={14}
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => {
                    return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                  }}
                  labelRowsPerPage={'Linhas por página'}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </table>
        </TableContainer>
      }
      <ConfirmDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleDelete}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
    </CustomThemeProvider>
  );
};
